var _path, _ellipse, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16C4 9.37258 9.37258 4 16 4V4C22.6274 4 28 9.37258 28 16V16C28 22.6274 22.6274 28 16 28V28C9.37258 28 4 22.6274 4 16V16Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9998,
    cy: 13.3333,
    rx: 5.33333,
    ry: 5.33333,
    fill: "url(#paint0_linear_538_14847)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3274 24.3829C24.3847 24.4797 24.367 24.6029 24.2856 24.6806C22.1317 26.7371 19.2134 28 16.0002 28C12.7871 28 9.8689 26.7371 7.71494 24.6807C7.63354 24.603 7.61582 24.4798 7.67318 24.383C9.21389 21.7822 12.3643 20 16.0003 20C19.6363 20 22.7867 21.7821 24.3274 24.3829Z",
    fill: "url(#paint1_linear_538_14847)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_14847",
    x1: 10.6665,
    y1: 13.3333,
    x2: 21.3332,
    y2: 13.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_14847",
    x1: 7.63965,
    y1: 24,
    x2: 24.3609,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileActive);
export default __webpack_public_path__ + "static/media/icon_profile_active.9b4d6fabb696c324776e992dc40abc37.svg";
export { ForwardRef as ReactComponent };